import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { loadOrganizationSyncPermissions } from '../../modules/App/AppActions';
import { getOrganizationSyncPermissions } from '../../modules/App/AppReducer';
import Progressbar from '../progress-bar';
import OwnerRenderer from '../table-cells/SaleRepsNameRenderer';
import PermissionTable from '../check-user-sync-permissions/permission-table';
import AzureSetupForm from '../../modules/Admin/components/AzureAppUser';
class CheckOrganizationSyncPermission extends Component {
  constructor(props) {
    super(props);
    const loaded = props.permissions !== undefined;

    this.state = {
      loaded,
      loadError: false,
      error: null,
      showHelp: false,
      noneLoginItegrateUsers: [],
    };
    if (!loaded) {
      this.props.dispatch(loadOrganizationSyncPermissions(props.organization._id))
        .then(
          () => {
            this.setState({ loaded: true });
          },
          (e) => {
            const errorCode = e.data?.code;
            const noneLoginItegrateUsers = e.data?.users || [];
            const showHelp = (errorCode === '400' || errorCode === 400);
            const message = e.data && e.data.message ? e.data.message : e.statusText;
            this.setState({ loadError: true, error: message, showHelp, noneLoginItegrateUsers });
          },
        );
    }
  }

  renderUserList() {
    const { permissions: { users }, organization } = this.props;
    return (
      <div>
        {users.map((user) => {
          return (
            <div key={user._id} className="panel panel-default">
              <div className="panel-heading">
                <div className="panel-title text-left">
                  {'Permissions Check for '}
                  {!user.is_application_user && <OwnerRenderer data={user} isOwner showAvatar value={user.display_name} />}
                  {user.is_application_user && <span>Application User</span>}
                  {':'}
                </div>
              </div>
              <div className="panel-body">
                {user.error !== undefined && <p className="text-danger text-left">{user.error}</p>}
                {user.error === undefined && <PermissionTable permissions={user.permissions} organization={organization} />}
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  listNoneLoginIntegrateUser() {
    const { noneLoginItegrateUsers } = this.state;
    if (noneLoginItegrateUsers?.length) {
      return (
        <div className="alert alert-warning">
          <p><strong>CRM Integration User required to be logged-in before sync to TruVoice Automation is enabled.</strong></p>
          <p>You can send the following invitation link to the CRM Integration User to login to TruVoice Automation:</p>
          <p />
          <div>
            {noneLoginItegrateUsers.map((u) => {
              return (<code key={u._id}>{u.invitation_link}</code>);
            })}
          </div>
        </div>
      );
    } else {
      return (
        <div className="alert alert-warning">
          <p><strong>CRM Integration User required to be logged-in before sync to TruVoice Automation is enabled.</strong></p>
          <p>This organization is missing an CRM integrate user.</p>
        </div>
      );
    }
    return null;
  }

  render() {
    const { loaded, loadError, error, showHelp } = this.state;
    const { permissions, forceShowList, showSetupForAzureonError, organization } = this.props;
    if (loadError) {
      const showSetup = showSetupForAzureonError && organization.type === 'azure';
      return (
        <div>
          {!showSetup &&
            <div>
              {!showHelp && <div className="alert alert-error">error</div>}
              {showHelp && this.listNoneLoginIntegrateUser()}
            </div>
          }
          {showSetup &&
            <div className="text-left">
              <AzureSetupForm
                modal={false}
                organization={organization}
              />
            </div>
          }
        </div>
      );
    }
    if (!loaded || !permissions) {
      return (
        <div>
          <p />
          <Progressbar />
          <p />
          <p className="text-muted">One moment please, checking your CRM permissions...</p>
        </div>
      );
    }
    const { hasError, hasWarning, hasSuccess } = permissions;

    if (hasError) {
      return (
        <div>
          {this.renderUserList()}
          <p className="alert alert-danger">Please fix the permission errors above before syncing your CRM data.</p>
          {hasSuccess && this.props.children}
        </div>
      );
    }
    return (
      <div>
        {(hasWarning || forceShowList) && this.renderUserList()}
        {this.props.children}
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state, ownProps) {
  return {
    permissions: getOrganizationSyncPermissions(state, ownProps.organization._id),
  };
}

CheckOrganizationSyncPermission.propTypes = {
  dispatch: PropTypes.func.isRequired,
  organization: PropTypes.shape({
    _id: PropTypes.string,
    type: PropTypes.string,
  }).isRequired,
  permissions: PropTypes.shape({
    hasError: PropTypes.bool,
    hasWarning: PropTypes.bool,
    hasSuccess: PropTypes.bool,
    users: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  children: PropTypes.node,
  forceShowList: PropTypes.bool,
  showSetupForAzureonError: PropTypes.bool,
};

CheckOrganizationSyncPermission.defaultProps = {
  children: null,
  forceShowList: false,
  showSetupForAzureonError: false,
};

export default connect(mapStateToProps)(CheckOrganizationSyncPermission);
